import { render, staticRenderFns } from "./Signage3.vue?vue&type=template&id=39997a1f&scoped=true"
import script from "./Signage3.vue?vue&type=script&lang=js"
export * from "./Signage3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39997a1f",
  null
  
)

export default component.exports